import { render, staticRenderFns } from "./campaign-streams.vue?vue&type=template&id=351dd04c&scoped=true&"
import script from "./campaign-streams.vue?vue&type=script&lang=js&"
export * from "./campaign-streams.vue?vue&type=script&lang=js&"
import style0 from "./campaign-streams.vue?vue&type=style&index=0&id=351dd04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351dd04c",
  null
  
)

export default component.exports